import React, { useState } from 'react';
import { Button, Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  FaArrowLeft,
  FaArrowRight,
  FaAward,
  FaChair,
  FaCouch,
  FaDollarSign,
  FaLeaf,
  FaStore,
  FaTable,
  FaTruck
} from 'react-icons/fa';
import { cloudinaryAsset } from '../config/media';

const asset = (folder, filename) => cloudinaryAsset(`/alquiler_mobiliario/${folder}/${filename}`);

const categories = [
  { key: 'chairs', icon: FaChair, image: 'Sillas.png' },
  { key: 'tables', icon: FaTable, image: 'Mesas.png' },
  { key: 'sofas', icon: FaCouch, image: 'Sillones.png' },
  { key: 'counters', icon: FaStore, image: 'Mostradores.png' },
  { key: 'decoration', icon: FaLeaf, image: 'Decoracion.png' },
  { key: 'accessories', icon: FaStore, image: 'Accesorios.png' }
];

const eventImages = Array.from({ length: 12 }, (_, index) =>
  asset('3.3 Eventos reales', `Mobiliario en eventos (${index + 1}).jpg`)
);

const benefits = [
  { key: 'quality', icon: FaAward },
  { key: 'delivery', icon: FaTruck },
  { key: 'advice', icon: FaChair },
  { key: 'pricing', icon: FaDollarSign }
];

const AlquilerMobiliario = () => {
  const { t } = useTranslation();
  const [eventIndex, setEventIndex] = useState(0);
  const [eventDirection, setEventDirection] = useState('next');
  const heroImage = asset('3.1 Hero', 'fotos hero mobiliario (5).jpg');
  const visibleEvents = Array.from({ length: 3 }, (_, offset) => eventImages[(eventIndex + offset) % eventImages.length]);

  const moveEvents = (direction) => {
    setEventDirection(direction > 0 ? 'next' : 'previous');
    setEventIndex((current) => (current + direction + eventImages.length) % eventImages.length);
  };

  return (
    <main id="alquiler-mobiliario" className="furniture-rental-page">
      <section className="furniture-rental-hero" style={{ backgroundImage: `linear-gradient(90deg, rgba(4, 19, 38, .92) 0%, rgba(4, 22, 48, .74) 43%, rgba(4, 22, 48, .1) 100%), url("${heroImage}")` }}>
        <Container>
          <div className="furniture-rental-hero-content">
            <h1>{t('furniturePage.hero.title')}</h1>
            <p>{t('furniturePage.hero.description')}</p>
            <Link to="/contacto" className="furniture-rental-primary-action">
              {t('furniturePage.requestCatalog')} <FaArrowRight aria-hidden="true" />
            </Link>
          </div>
        </Container>
      </section>

      <section className="furniture-categories">
        <Container>
          <div className="furniture-section-heading">
            <h2>{t('furniturePage.categoriesTitle')}</h2>
            <p>{t('furniturePage.categoriesDescription')}</p>
          </div>
          <div className="furniture-category-grid">
            {categories.map(({ key, icon: Icon, image }) => (
              <article className="furniture-category-card" key={key}>
                <img src={asset('3.2 Categorías de mobiliario', image)} alt={t(`furniturePage.categories.${key}`)} loading="lazy" />
                <div className="furniture-category-icon"><Icon aria-hidden="true" /></div>
                <div className="furniture-category-copy">
                  <h3>{t(`furniturePage.categories.${key}`)}</h3>
                  <p>{t('furniturePage.categoryDescription')}</p>
                </div>
              </article>
            ))}
          </div>
          <div className="furniture-catalog-action">
            <Link to="/contacto" className="furniture-rental-secondary-action">
              {t('furniturePage.requestCatalog')} <FaArrowRight aria-hidden="true" />
            </Link>
          </div>
        </Container>
      </section>

      <section className="furniture-events">
        <Container>
          <div className="furniture-section-heading">
            <h2>{t('furniturePage.eventsTitle')}</h2>
            <p>{t('furniturePage.eventsDescription')}</p>
          </div>
          <div className="furniture-events-slider">
            <Button className="furniture-slider-control previous" onClick={() => moveEvents(-1)} aria-label={t('furniturePage.previousImages')}>
              <FaArrowLeft />
            </Button>
            <div key={eventIndex} className={`furniture-events-track is-moving-${eventDirection}`} aria-live="polite">
              {visibleEvents.map((image, index) => (
                <img key={image} src={image} alt={t('furniturePage.eventImage', { number: (eventIndex + index) % eventImages.length + 1 })} />
              ))}
            </div>
            <Button className="furniture-slider-control next" onClick={() => moveEvents(1)} aria-label={t('furniturePage.nextImages')}>
              <FaArrowRight />
            </Button>
          </div>
        </Container>
      </section>

      <section className="furniture-benefits">
        <Container>
          <div className="furniture-section-heading">
            <h2>{t('furniturePage.benefitsTitle')}</h2>
          </div>
          <div className="furniture-benefits-grid">
            {benefits.map(({ key, icon: Icon }) => (
              <article className="furniture-benefit" key={key}>
                <Icon aria-hidden="true" />
                <h3>{t(`furniturePage.benefits.${key}.title`)}</h3>
                <p>{t(`furniturePage.benefits.${key}.description`)}</p>
              </article>
            ))}
          </div>
        </Container>
      </section>

      <section className="furniture-rental-cta" style={{ backgroundImage: `linear-gradient(90deg, rgba(5, 42, 88, .97), rgba(11, 63, 126, .89), rgba(5, 42, 88, .4)), url("${eventImages[6]}")` }}>
        <Container className="furniture-rental-cta-content">
          <div>
            <h2>{t('furniturePage.cta.title')}</h2>
            <p>{t('furniturePage.cta.description')}</p>
          </div>
          <Link to="/contacto" className="furniture-rental-cta-action">
            {t('furniturePage.requestCatalog')} <FaArrowRight aria-hidden="true" />
          </Link>
        </Container>
      </section>
    </main>
  );
};

export default AlquilerMobiliario;
